import { IsInt, IsNumber, IsOptional, Max, Min } from 'class-validator';
import { applyDecorators } from '../utils';

type IsValidNumberOptions = {
  integer?: boolean;
  min?: number;
  max?: number;
  optional?: boolean;
};

export function IsValidNumber(options: IsValidNumberOptions = {}) {
  const decorators = options.integer
    ? [IsInt({ context: { messageKey: 'common.validationErrors.integer' } })]
    : [
        IsNumber(
          {},
          { context: { messageKey: 'common.validationErrors.number' } },
        ),
      ];

  if (options.min !== undefined) {
    decorators.push(
      Min(options.min, {
        context: {
          messageKey: 'common.validationErrors.min',
          data: { min: options.min },
        },
      }),
    );
  }

  if (options.max !== undefined) {
    decorators.push(
      Max(options.max, {
        context: {
          messageKey: 'common.validationErrors.max',
          data: { max: options.max },
        },
      }),
    );
  }

  if (options.optional) {
    decorators.push(IsOptional());
  }

  return applyDecorators(...decorators);
}
